angular
    .module('claimVic.controller',['bw.paging']);